import { Outlet } from 'react-router';
import { ApplicationNav } from '@/features/ApplicationForm/Components/ApplicationNav';

export function ApplicationFormReportsLayout() {
  return (
    <>
      <ApplicationNav />
      <Outlet />
    </>
  );
}
